import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { getUserData, UserProps } from '@services/usersService';
import { AUTH_EXCLUDED_PATHS } from '@utils/publicPaths';
import { queryKeys } from './queryKeys';

const excludedPaths = AUTH_EXCLUDED_PATHS;

export const useUser = () => {
  const location = useLocation();
  const isExcluded = excludedPaths.includes(location.pathname);

  const { data: user, isLoading, error, dataUpdatedAt } = useQuery<UserProps>({
    queryKey: queryKeys.user,
    queryFn: getUserData,
    enabled: !isExcluded,
    // On first social sign-up `/users` can 401 briefly while the domain user provisions. Retry
    // a couple of times before giving up so the recovered request refetches instead of the
    // session-aware interceptor ejecting a genuinely authenticated user to /login.
    retry: (failureCount, err: unknown) =>
      (err as { response?: { status?: number } })?.response?.status === 401 && failureCount < 2,
    retryDelay: (attempt) => Math.min(500 * 2 ** attempt, 2000),
  });

  return {
    user: user ?? null,
    isLoading,
    error,
    dataUpdatedAt,
  };
};
